import { render } from "./VacancySelection.vue?vue&type=template&id=5a62a679&scoped=true"
import script from "./VacancySelection.vue?vue&type=script&lang=js"
export * from "./VacancySelection.vue?vue&type=script&lang=js"

import "./VacancySelection.vue?vue&type=style&index=0&id=5a62a679&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a62a679"]])

export default __exports__